// @ts-check
import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import { StoreContext } from "../../../../../../store/StoreProvider";
import Selection from "../../../../../../common/components/input/Selection";
//
import Act from "../../../../../../store/actions";
import urls from "../../../../../../api/project/ApiUrls";

/**
 *
 * @param options {{key:string, label:string, value:string}[]}
 * @returns {JSX.Element}
 * @constructor
 */
// @ts-ignore
const CommonAccDetailChildren = ({ options }) => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  // @ts-ignore
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale, group } = user;
  const { analytics } = sna;
  const { analyticsType } = analytics || {};
  // local state
  const [localOptions, setLocalOptions] = useState(options);
  const [inputVal, setInputVal] = useState(analyticsType.change);

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  useEffect(() => {
    if (analyticsType) {
      setInputVal(analyticsType.initial);
    }
  }, [analyticsType]);

  /**
   *
   * @param e {React.ChangeEvent<HTMLInputElement>}
   */
  const handleInputChange = (e) => {
    const { value } = e.target;
    setInputVal(value);
    dispatch({
      type: Act.SNA_ANALYTICS_TYPE_CHANGE,
      payload: value,
    });
  };

  return (
    <Box>
      <Selection
        options={localOptions}
        size="normal"
        darkMode
        fullWidth
        inputProps={{
          value: inputVal,
          onChange: handleInputChange,
          // defaultValue: "",
        }}
        MenuProps={{}}
      />
    </Box>
  );
};

CommonAccDetailChildren.propTypes = {
  options: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
};

CommonAccDetailChildren.defaultProps = {
  options: [],
};

export default CommonAccDetailChildren;
